import React, { useState, ReactElement, useContext } from "react";
import CTEPForm from "./forms/ctepForm";
import CTEPDynamicForm from "./forms/ctepDynamicForm";
import CTEPLoad from "./loading/ctepLoad";
import CTEPDownload from "./download/ctepDownloadPage";
import ProgressBar from "./progressBar";
import {
    FormContainer,
    Forms
} from "./ctepContainer.styled"
import { AuthContext } from "core/contexts/auth/auth";
import { useAppDispatch } from "core/store/reduxStore";
import {
    setUserInput,
    addToConversation,
} from "modules/chat/store/conversationList";
import { getConversationsFromApi } from "modules/chat/services/chatService";

function CTEPContainer(props) {
    const dispatch = useAppDispatch();
    const { checkAMSToken, amsUser } = useContext(AuthContext);
    const [pageNum, setPageNum] = useState(1);
    const [pageName, setPageName] = useState('current');
    const [pageNumMax, setPageNumMax] = useState(5);
    const [questionList, setQuestionList] = useState({});
    const [errorThrown, setErrorThrown] = useState(false);
    const [intakeData, setintakeData] = useState({});
    const [downloadLink, setDownloadLink] = useState('')
    const [dynamicFormData, setDynamicFormData] = useState({})

    let firstFormInfo = {}
    let domains = []
    let currentDomain = 0;
    let formatQuestions = {}

    function settingPageName(page) {
        switch (page) {
            case 1:
                setPageName('current')
                props.onPageChange('current');
                break;
            case 2:
                setPageName('loading questions')
                props.onPageChange('loading questions');
                break;
            case 3:
                setPageName('dynamic')
                props.onPageChange('dynamic');
                break;
            case 4:
                setPageName('loading report')
                props.onPageChange('loading report');
                break;
            case 5:
                setPageName('download')
                props.onPageChange('download');
                break;
        }
    }

    function nextPage() {
        if (pageNum !== pageNumMax) {
            setPageNum(pageNum + 1);
            let page = pageNum + 1
            settingPageName(page)
        }
    }

    function prevPage() {
        if (pageNum === 3) {
            setPage(1)
        } else {
            setPage(3)
        }
    }

    function setPage(page) {
        setPageNum(page);
        settingPageName(page)
    }

    const getLatestConversation = async (token, form, timeout) => {
        let message;
        getConversationsFromApi(token).then((list) => {
            let messageInfo = (list[list.length - 1].messages[list[list.length - 1].messages.length - 1])
            if (messageInfo.role === "user" && timeout < 900) {
                const timer = setTimeout(() => {
                    getLatestConversation(token, form, timeout);
                }, 2000);
                timeout = timeout + 1
            } else if (messageInfo.role === "assistant") {
                message = messageInfo.content
                try {
                    if (form === 1) {
                        if (currentDomain === 0) {
                            message = message.slice(message.indexOf('{'), message.lastIndexOf('}') + 1)
                            message = JSON.parse(message);
                            formatQuestions = message
                        } else {
                            message = message.slice(message.indexOf('{'), message.lastIndexOf('}') + 1)
                            message = JSON.parse(message);
                            formatQuestions = Object.assign({ ...formatQuestions }, message)
                        }

                        if (currentDomain === domains.length - 1) {
                            setQuestionList(formatQuestions)
                            console.log(formatQuestions)
                            setPage(3)
                        } else {
                            currentDomain++;
                            sendPromptToApiFirstForm(firstFormInfo, currentDomain)
                        }

                    } else if (form === 2) {
                        setDownloadLink(message)
                        setPage(5)
                    }

                } catch (e) {
                    setErrorThrown(true)
                    console.log(e)
                }
            } else {
                console.log("Error")
                setErrorThrown(true)
            }
        });
    }

    const configureDomainInformation = (value) => {
        setintakeData(value.data.intake_data)
        firstFormInfo = JSON.parse(JSON.stringify(value))
        domains = value.data.intake_data.securityDomains
        sendPromptToApiFirstForm(firstFormInfo, 0)
    }

    const sendPromptToApiFirstForm = async (value, domain) => {
        value.data.intake_data.securityDomains = [domains[domain]]
        const token = await checkAMSToken();
        value = JSON.stringify(value)

        // If it's a text input, proceed as normal
        console.log(value)
        dispatch(setUserInput(value));
        dispatch(
            addToConversation({
                accessToken: token,
                userPrompt: value,
                userEmail: amsUser?.email || "",
                socket: props.socket,
            })
        );

        const timer = setTimeout(() => {
            getLatestConversation(token, 1, 0)
        }, 5000);

    };

    const sendPromptToApiSecondForm = async (value, downloadType) => {
        setDynamicFormData(value);
        let excel_data = {}
        let data = {}
        excel_data = { ...excel_data, "report_data": value }
        excel_data = { ...excel_data, "intake_data": intakeData }
        excel_data = { ...excel_data, "report_type": downloadType } //need logic here for pdf 
        data = { ...data, "data": excel_data }
        data = { ...data, "identifierFlag": "generate report" }
        console.log(data)
        const token = await checkAMSToken();
        value = JSON.stringify(data)
        // If it's a text input, proceed as normal
        dispatch(setUserInput(value));
        dispatch(
            addToConversation({
                accessToken: token,
                userPrompt: value,
                userEmail: amsUser?.email || "",
                socket: props.socket,
            })
        );
        //Race condition prevention. Can be improved upon, can fix at later date
        const timer = setTimeout(() => {
            getLatestConversation(token, 2, 0)
        }, 5000);

    };

    return (
        <FormContainer>
            <Forms>
                {pageNum === 1 ? <CTEPForm onNextButtonClick={nextPage} handlePromptSubmit={configureDomainInformation}></CTEPForm> :
                    pageNum === 2 || pageNum === 4 ? <CTEPLoad onNextButtonClick={nextPage} pageNum={pageNum} errorThrown={errorThrown}></CTEPLoad> :
                        pageNum === 3 ? <CTEPDynamicForm onNextButtonClick={nextPage} onPrevButtonClick={prevPage} formData={dynamicFormData} questionList={questionList} handlePromptSubmit={sendPromptToApiSecondForm}></CTEPDynamicForm> :
                            pageNum === 5 ? <CTEPDownload downloadLink={downloadLink} onPrevButtonClick={prevPage}></CTEPDownload> :
                                <div />}
            </Forms>
        </FormContainer>
    );
}

export default CTEPContainer;
